import { useRouter } from 'next/router';
import { createContext, useState, useEffect } from 'react';
import { isWebviewPath, isEmbedPath } from 'utils/pathHelper';

export const ProducteContext = createContext();

const ProducteProvider = (props) => {
    const { children } = props;
    const router = useRouter();
    const [isWebviewActive, setIsWebviewActive] = useState(isWebviewPath(router.asPath) || isEmbedPath(router.asPath));
    const [isClient, setIsClient] = useState(false);

    const urlAppPrefix = 'web';
    const isTv = false;

    useEffect(() => {
        setIsClient(true);
        const webviewActive = isWebviewPath(router.asPath) || isEmbedPath(router.asPath);
        setIsWebviewActive(webviewActive);

        if (webviewActive) {
            document.body.classList.add('webview');
        }
    }, [router.asPath]);

    return (
        <ProducteContext.Provider value={{ urlAppPrefix, isWebviewActive, isTv, isClient }}>{children}</ProducteContext.Provider>
    );
};

export default ProducteProvider;
